



































































































































































































































































































































































import { Component, Vue, Prop, Watch } from 'vue-property-decorator';
import { Family } from '@/interfaces/Models';
import axios from 'axios';
import { api } from '@/api';
import LanguagePicker from '@/components/dashboard/shared/components/LanguagePicker.vue';
import { State, Getter, Action, Mutation } from 'vuex-class';

@Component({
  components: {
    LanguagePicker,
  },
})
export default class FamilyProfile extends Vue {
  public family!: Family;

  @Prop()
  id!: number;

  public menu: boolean = false;

  public family_name: string = '';
  public primaryParent: number | null = null;
  public babysittingLanguage: number | null = null;
  public contact: string = '';

  public address_id: any = null;

  public address: any = {
    address: '',
    area_name: '',
    city: '',
    district: '',
    postal_code: '',
    geo_location: '',
  };

  public familyPets: any = [];

  public children: any = [];

  public parents: any = [];

  public babysittingPreferences: any = {
    covid_vaccinated: false,
  };

  public dataLoading: boolean = true;

  public genders: any[] = [
    {
      text: 'male',
      value: 0,
    },
    {
      text: 'female',
      value: 1,
    },
  ];

  public nationalities: any = [];
  /* public languages: any = []; */
  /* public get languages() {

        } */
  public pets: any = [];

  public get tabs(): any[] {
    return [
      {
        text: this.$t('families.edit.family.title'),
        icon: 'mdi-home',
      },
      {
        text: this.$t('families.edit.children.title'),
        icon: 'mdi-account-child',
      },
      {
        text: this.$t('families.edit.parents.title'),
        icon: 'mdi-human-male-female',
      },
      {
        text: 'sitting preferences',
        icon: 'mdi-tune',
      },
    ];
  }

  /* public saveFamily() {
            let payload = {
                family_name: this.family_name,
                primary_parent_id: this.primaryParent,
                contact: this.contact,
                address: this.address,
                pets: this.familyPets,
            }

            axios.put(api.path('v1.p.profile', { id: this.family.id }), payload)
                .then( res =>   this.$toast.success(res.data.message) );
        } */

  public saveFamily() {
    this.dataLoading = true;

    let payload = {
      family_name: this.family_name,
      primary_parent_id: this.primaryParent,
      babysitting_language_id: this.babysittingLanguage,
      contact: this.contact,
      address: this.address,
      pets: this.familyPets,
    };

    axios
      .put(api.path('v1.p.profile', { id: this.family.id }), payload)
      .then((res) => this.$toast.success(res.data.message))
      .finally(() => (this.dataLoading = false));
  }

  public getChildrenPayload() {
    return this.children.map((child: any) => {
      child.languages = {
        ...child.selectedLanguages,
      };
      return child;
    });
  }

  /* public saveChildren() {

            let childrenPayload = this.getChildrenPayload();

            axios.put(api.path('v1.p.profile.updateChildren', { id: this.family.id }), { children: childrenPayload })
                .then(res => this.$toast.success(res.data.message));
        } */

  public saveChildren() {
    this.dataLoading = true;

    let childrenPayload = this.getChildrenPayload();

    axios
      .put(api.path('v1.p.profile.updateChildren', { id: this.family.id }), {
        children: childrenPayload,
      })
      .then(async (res) => {
        this.$toast.success(res.data.message);
        await this.loadFamily();
      })
      .finally(() => (this.dataLoading = false));
  }

  public getParentsPayload() {
    return this.parents.map((parent: any) => {
      parent.languages = {
        ...parent.selectedLanguages,
      };
      return parent;
    });
  }

  /*  public saveParents() {

            let parentsPayload = this.getParentsPayload();

            axios.put(api.path('v1.p.profile.updateParents', { id: this.family.id }), { parents: parentsPayload })
                .then( res => this.$toast.success(res.data.message));
        } */

  public async saveParents() {
    this.dataLoading = true;

    let parentsPayload = this.getParentsPayload();

    await axios
      .put(api.path('v1.p.profile.updateParents', { id: this.family.id }), {
        parents: parentsPayload,
      })
      .then(async (res) => {
        this.$toast.success(res.data.message);
        await this.loadFamily();
      })
      .finally(() => (this.dataLoading = false));
  }

  public async saveBabysittingPreferences() {
    this.dataLoading = true;

    let payload = { ...this.babysittingPreferences };

    await axios
      .put(
        api.path('v1.p.profile.babysittingPreferences', { id: this.family.id }),
        payload
      )
      .then(async (res) => {
        this.$toast.success(res.data.message);
      })
      .finally(() => (this.dataLoading = false));
  }

  /* public addChild() {

            this.children.push({
                id: null,
                first_name: '',
                gender: null,
                date_of_birth: '',
                address_id: null,
                address_name: '',
                area_name: '',
                city: '',
                languages: [],
                menu: false,
            });

        } */

  /* public addParent() {

            this.parents.push({
                id: null,
                first_name: '',
                last_name: '',
                contact: '',
                email: '',
                nationality_id: null,
                languages: [],
            });

        } */

  public removeChild(index: any) {
    this.children = this.children.filter(
      (child: any, cIndex: any) => cIndex !== index
    );
  }

  public removeParent(index: any) {
    this.parents = this.parents.filter(
      (parents: any, pIndex: any) => pIndex !== index
    );
  }

  public async loadNationalities() {
    let params = {
      paginate: 'no',
    };

    await axios
      .get(api.path('v1.nationalities'), { params: params })
      .then((res) => (this.nationalities = res.data.data));
  }

  public async loadLanguages() {
    let params = {
      paginate: 'no',
    };

    let response = await axios.get(api.path('v1.languages'), {
      params: params,
    });

    /* .then( res => this.languages = res.data.data ); */
  }

  public async loadPets() {
    let params = {
      paginate: 'no',
    };

    await axios
      .get(api.path('v1.pets'), { params: params })
      .then((res) => (this.pets = res.data.data));
  }

  public $refs!: {
    picker: any;
  };

  @Watch('children', { deep: true })
  onChange(value: any, old: any) {
    value.forEach((element: any, i: any) => {
      if (element.menu) {
        element.menu &&
          setTimeout(() => (this.$refs.picker[i].activePicker = 'YEAR'));
      }
    });
  }

  public async loadFamily(): Promise<void> {
    let res = await axios.get(api.path('v1.p.profile.edit'));

    this.family = res.data.data;
    this.setFamily(res.data.data);
  }

  public setFamily(family: Family) {
    this.family_name = family.family_name;
    this.contact = family.contact;
    this.primaryParent = family.parent?.id;
    this.babysittingLanguage = family.babysittingLanguage?.id;

    this.address = family.address;

    this.familyPets = family.pets?.map((pet) => pet.id);

    this.children = family.children?.map((child) => {
      child.menu = false;

      child.address_name = child.address ? child.address.address : '';
      child.city = child.address ? child.address.city : '';
      child.area_name = child.address ? child.address.area_name : '';
      child.address_id = child.address ? child.address.id : null;

      child.selectedLanguages = [];

      if (child.nativeLanguage) {
        child.languages.push(child.nativeLanguage);
      }

      if (child.languages.length > 0) {
        child.languages.forEach((lang: any) =>
          this.$set(child.selectedLanguages, lang.id, {
            language_level: lang.level?.id,
          })
        );
      }

      return child;
    });

    this.parents = family.parents?.map((parent) => {
      parent.first_name = parent.first_name ?? '';
      parent.last_name = parent.last_name ?? '';
      parent.contact = parent.contact ?? '';
      parent.email = parent.email ?? '';

      parent.selectedLanguages = [];

      if (parent.nativeLanguage) {
        parent.languages.push(parent.nativeLanguage);
      }

      if (parent.languages.length > 0) {
        parent.languages.forEach((lang: any) =>
          this.$set(parent.selectedLanguages, lang.id, {
            language_level: lang.level?.id,
          })
        );
      }

      return parent;
    });

    this.babysittingPreferences.covid_vaccinated =
      family?.babysittingPreferences?.covid_vaccinated ?? false;
  }

  @Action('languages/fetchLanguages') fetchLanguages: any;
  @Getter('languages/languages') languages: any;

  @Action('cities/fetchCities') fetchCities: any;
  @Getter('cities/cities') cities: any;

  public async mounted() {
    await this.fetchCities();
    await this.fetchLanguages();
    await this.loadNationalities();
    await this.loadPets();

    await this.loadFamily();

    this.dataLoading = false;
  }
}
